export default __webpack_public_path__ + "static/media/13.0e135f88.JPG";